export const InventoryBookModuleSymbol = Symbol('inventoryBookModule');
